import React, { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "emotion-theming";
import { useHistory } from "react-router-dom";
import { Text } from "@nykaa/payment-ui/src/Text";
import { FilledButton } from "@nykaa/payment-ui/src/Button";
import { CircularLoader } from "@nykaa/payment-ui/src/CircularLoader";

import { get } from "logics/src/utils/helpers";
import { SavedPaymentView } from "layouts/SavedPayment";
import { NewPaymentDetails } from "layouts/CheckoutPayment/mobile/NewPaymentDetails";
import { MorePaymentMethod } from "layouts/CheckoutPayment/mobile/AllSavedPaymentMethod/MorePaymentMethod";
import { ShippingAddress } from "layouts/CheckoutPayment/mobile/ShippingAddress";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { default as WalletMultiModal } from "layouts/Payment/WalletMultimodal";
import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { PAYMENT_SCREENS } from "constants/paymentScreens";
import { UserContext } from "wrapper/UserWrapper/context";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { checkIsAddressIdDelCookiePresent } from "layouts/Payment/common/dependencies/dependencyhelpers";
import { getStorageData } from "helpers/utils/storage";
import { PAYTM_AUTOPAY } from "constants/cookies";
import { MainLoaderLoayoutWrapper } from "layouts/CheckoutPayment/assets/style";
import { SavedPaymentWrapper } from "layouts/SavedPayment/assets/style";
import PaymentView from "layouts/Payment/Loadable";
import { ErrorBoundary } from "components/ErrorBoundary";
import { RetryWalletTile } from "components/RetryWalletTile";
import PaymentOffers from "layouts/PaymentOffers/Loadable";
import { CouponCard } from "components/CouponCard";
import { doRedirect } from "helpers/utils/redirection";
import { OTHER_URLS } from "constants/urls";
import { BUY_NOW_FLOW_QUERY_PARAM } from "constants/index";
import { NonCollectedApplicableCoupon } from "store/payment/transformers/cart/applicableCouponTransformer";
import { CouponBottomSheet, CouponBottomSheetProps } from "components/CouponBottomSheet";
import { getCouponDetails } from "store/payment/services";
import { logger } from "logging";
import { CouponDetails } from "store/payment/@types";
import { shouldAppendBuyNowApiParam as isBuyNowFlow } from "helpers/utils/buyNowCheckoutFlow";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getPlatform } from "../../../../helpers";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { checkIsExperimentEligible } from "helpers/utils/isExperimentEligible";
import { useEddConfig } from "hooks/useEdd";

import { DeliveryToast } from "../DeliveryToast";
import {
  BuyerAssuranceWrapper,
  CouponTitleWrapper,
  CouponWrapper,
  DeliveryEstimateBuyNowWrapper,
  LoginCTAWrapper,
  SectionTitleWrapper,
  SectionWrapper,
} from "./assets/styles";
import { BuyerAssurance } from "../AllPaymentMethod/components/BuyerAssurance";
import { ShippingAddressContent } from "../ShippingAddress/assets/style";
import DeliveryEstimate from "../EstimateDelivery";
import { AddressNotMatchedMessageCard } from "../AddressNotMatchedMessageCard";


interface ISavePaymentBuyNowView {
  setIsWalletChecked: any;
  timerCallback: any;
  setUpiDetails: any;
  isGPayIntentAvailable: boolean;
  loading: boolean;
  showAllPaymentMethods: boolean;
  setPaymentScreen: any;
  isDeliveryEstimateToastVisible: boolean;
  setIsDeliveryEstimateToastVisible: React.Dispatch<React.SetStateAction<boolean>>;
  areSavedPaymentMethodsDisplayed: boolean;
  isSavedPaymentVisible: boolean;
  isNewPaymentMethodVisible: boolean;
  isWalletDisplayed: boolean;
  newPaymentMethod: any;
  priceDetailConfig: any;
  proceedToPayVisible: boolean;
  isFailureUrl: boolean;
}

export const SavePaymentBuyNowView = ({
  setIsWalletChecked,
  timerCallback,
  setUpiDetails,
  isGPayIntentAvailable,
  loading,
  showAllPaymentMethods,
  setPaymentScreen,
  isDeliveryEstimateToastVisible,
  setIsDeliveryEstimateToastVisible,
  areSavedPaymentMethodsDisplayed,
  isSavedPaymentVisible,
  isNewPaymentMethodVisible,
  isWalletDisplayed,
  newPaymentMethod,
  priceDetailConfig,
  proceedToPayVisible,
  isFailureUrl,
}: ISavePaymentBuyNowView) => {
  const history = useHistory();
  const platform = getPlatform();
  const theme: Theme = useTheme();
  const paymentContext = useContext(PaymentContext);
  const { userData } = useContext(UserContext);
  const { applicationData } = useContext(ApplicationContext);
  const { PaymentOfferRevamp, EddPosition2 } = useContext(ExperimentAndSwitchContext);

  const walletConfig = paymentContext?.walletConfig;
  const giftCardConfig = paymentContext?.giftCardInfoConfig;
  const orderAmount = paymentContext?.orderAmount;
  const cartInfo = get(paymentContext, "cartInfo");
  const offersData: any = get(paymentContext, "offersData");
  const nonCollectedApplicableCoupon = get(cartInfo, "nonCollectedApplicableCoupon");
  const appliedCoupons = get(cartInfo, "appliedCoupons");
  const grandTotal = get(cartInfo, "grandTotal");
  const walletBalance = get(walletConfig, "walletBalance");
  const isFullPaymentByGiftCard = get(giftCardConfig, "isFullPaymentByGiftCard");
  const { isGuest } = userData;
  const flowConfig = get(paymentContext, "flowConfig");
  const { isApp } = applicationData;
  const setLoading = get(paymentContext, "setLoading");
  const isPaymentInfoLoading = paymentContext?.isPaymentInfoLoading;
  const visibleOfferBottomSheet = paymentContext?.visibleOfferBottomSheet;
  const setVisibleOfferBottomSheet = paymentContext?.setVisibleOfferBottomSheet;
  const paymentScreen = get(paymentContext, "paymentScreen");
  const showRetryWalletTile = paymentContext?.showRetryWalletTile;
  const isRetryWalletExpEnabled = paymentContext?.isRetryWalletExpEnabled;
  const handleRetryWalletClick = paymentContext?.handleRetryWalletClick;
  const handleApplyCoupon = paymentContext?.handleApplyCoupon;
  const handleRemoveCoupon = paymentContext?.handleRemoveCoupon;

  const query = new URLSearchParams(history.location.search);
  const autoCreateOrder = query.get("autoCreateOrder");
  const payTmAutoPay = getStorageData(PAYTM_AUTOPAY, false) || "false";
  const autoPayTmCreateOrder = autoCreateOrder === "true" && payTmAutoPay === "true";

  const loginSectionTitle = getStringFromId(
    VERNACULAR_STRING_IDS.LOGIN_SECTION_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.LOGIN_SECTION_TITLE
  );
  const couponSectionTitle = getStringFromId(
    VERNACULAR_STRING_IDS.COUPON_SECTION_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.COUPON_SECTION_TITLE
  );
  const couponSectionSubTitle = getStringFromId(
    VERNACULAR_STRING_IDS.COUPON_SECTION_SUBTITLE,
    VERNACULAR_DEFAULT_MESSAGES.COUPON_SECTION_SUBTITLE
  );
  const SavedPaymentOption = getStringFromId(
    VERNACULAR_STRING_IDS.SAVED_PAYMENT_OPTIONS,
    VERNACULAR_DEFAULT_MESSAGES.SAVED_PAYMENT_OPTIONS
  );
  const loginCTA = getStringFromId(
    VERNACULAR_STRING_IDS.LOGIN_CTA,
    VERNACULAR_DEFAULT_MESSAGES.LOGIN_CTA
  );
  const defaultAddressMessage = getStringFromId(
    VERNACULAR_STRING_IDS.DEFAULT_ADDRESS_MESSAGE,
    VERNACULAR_DEFAULT_MESSAGES.DEFAULT_ADDRESS_MESSAGE
  );
  const toastDeliveryMessage = getStringFromId(
    VERNACULAR_STRING_IDS.TOAST_DELIVERY_MESSAGE,
    VERNACULAR_DEFAULT_MESSAGES.TOAST_DELIVERY_MESSAGE
  );
  const NykaaWalletTitle = getStringFromId(
    VERNACULAR_STRING_IDS.NYKAA_WALLET_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.NYKAA_WALLET_TITLE
  );
  const OrderInformation = getStringFromId(
    VERNACULAR_STRING_IDS.ORDER_INFORMATION,
    VERNACULAR_DEFAULT_MESSAGES.ORDER_INFORMATION
  );
  const unableToFetchWalletText = getStringFromId(
    VERNACULAR_STRING_IDS.UNABLE_TO_FECTH_WALLLET,
    VERNACULAR_DEFAULT_MESSAGES.UNABLE_TO_FECTH_WALLLET
  );
  const retryButtonText = getStringFromId(
    VERNACULAR_STRING_IDS.RETRY,
    VERNACULAR_DEFAULT_MESSAGES.RETRY
  );

  const [selectedCoupon, setSelectedCoupon] = useState<CouponBottomSheetProps | null>(null);
  const [isScrollToEddElement, setIsScrollToEddElement] = useState(false);
  const deliveryElementRef = useRef(null);
  const isAddressIdDelCookiePresent = checkIsAddressIdDelCookiePresent();

  const handleLoginRedirection = () => {
    doRedirect({
      url: `${OTHER_URLS.AUTH_PAGE}&${BUY_NOW_FLOW_QUERY_PARAM}=true`,
      isClientRedirection: false,
    });
  };

  const showCouponDetails = (couponId: number, isApplied: boolean, label: string) => {
    getCouponDetails(couponId)
      .then((response: CouponDetails) => {
        if (response && response.success) {
          setSelectedCoupon({
            isVisible: true,
            onClose: () => setSelectedCoupon(null),
            couponCode: response.data.couponCode,
            couponImage: response.data.imageUrl,
            couponTitle: response.data.title,
            couponSubTitle: response.data.subtitle,
            couponTnC: response.data.tnc,
            title: label,
            isApplied: isApplied,
            onApplyCoupon: () => handleApplyCoupon(response.data.couponCode, response.data),
          });
        }
      })
      .catch(err => {
        logger.error(err, "Error in fetching coupon details");
        setSelectedCoupon(null);
      });
  };

  const eddConfig = useEddConfig({
    isExpanded: true,
    deliveryElementRef: deliveryElementRef,
    isApp,
  });

  if (isScrollToEddElement) {
    setTimeout(() => {
      (deliveryElementRef?.current as any)?.scrollIntoView({ behavior: "smooth" });
      if (!loading) {
        setIsScrollToEddElement(false);
      }
    }, 100);
  }

  setTimeout(() => {
    setIsDeliveryEstimateToastVisible(false);
  }, 5000);

  return (
    <div className="layout vertical mt20 mb10">
      {flowConfig?.address && (
        <ShippingAddressContent>
          <AddressNotMatchedMessageCard
            isAddressIdDelCookiePresent={isAddressIdDelCookiePresent}
            defaultAddressMessage={defaultAddressMessage}
            leadingIcon={getIcons(platform, ICONS_NAMES.EDD_INFO_ICON)}
          />
          <ShippingAddress addressBarDataTestId="txt_address_bar" />
        </ShippingAddressContent>
      )}

      {flowConfig?.edd && (
        <DeliveryEstimateBuyNowWrapper>
          <DeliveryEstimate {...eddConfig} platform={platform} isWidgetVisible={true} />
        </DeliveryEstimateBuyNowWrapper>
      )}

      {isBuyNowFlow() && isGuest && (
        <LoginCTAWrapper>
          <Text
            font={theme?.typography?.type142}
            color={theme.primaryText}
            text={loginSectionTitle}
          />
          <FilledButton text={loginCTA} onClick={handleLoginRedirection} buttonType="medium" />
        </LoginCTAWrapper>
      )}

      {isBuyNowFlow() &&
        !isGuest &&
        (nonCollectedApplicableCoupon?.length > 0 || appliedCoupons?.length > 0) && (
          <>
            <CouponTitleWrapper>
              <Text
                text={couponSectionTitle}
                font={theme.typography.sectionTitle}
                color={theme.primaryText}
                theme={theme}
              />
              <Text
                text={couponSectionSubTitle}
                font={theme.typography.bodySmall}
                color={theme.colors.textSecondary}
                theme={theme}
              />
            </CouponTitleWrapper>
            <CouponWrapper>
              {appliedCoupons?.map((coupon: NonCollectedApplicableCoupon) => (
                <CouponCard
                  key={coupon.couponId}
                  logoUrl={coupon.imageUrl}
                  savingsText={coupon.label}
                  description={coupon.subText}
                  couponCode={coupon.couponCode}
                  isApplied
                  onCTAClick={() => handleRemoveCoupon(coupon.couponCode)}
                  onClick={() => showCouponDetails(coupon.couponId, true, coupon.label)}
                />
              ))}
              {nonCollectedApplicableCoupon?.map((coupon: NonCollectedApplicableCoupon) => (
                <CouponCard
                  key={coupon.couponId}
                  logoUrl={coupon.imageUrl}
                  savingsText={coupon.label}
                  description={coupon.subText}
                  couponCode={coupon.couponCode}
                  onCTAClick={() => handleApplyCoupon(coupon.couponCode, coupon)}
                  onClick={() => showCouponDetails(coupon.couponId, false, coupon.label)}
                />
              ))}
              {selectedCoupon && (
                <CouponBottomSheet
                  isVisible={selectedCoupon.isVisible}
                  onClose={selectedCoupon.onClose}
                  title={selectedCoupon.title}
                  couponCode={selectedCoupon.couponCode}
                  couponImage={selectedCoupon.couponImage}
                  couponTitle={selectedCoupon.couponTitle}
                  couponSubTitle={selectedCoupon.couponSubTitle}
                  couponTnC={selectedCoupon.couponTnC}
                  isApplied={selectedCoupon.isApplied}
                  onApplyCoupon={selectedCoupon.onApplyCoupon}
                />
              )}
            </CouponWrapper>
          </>
        )}

      {isPaymentInfoLoading && !isFailureUrl ? (
        <MainLoaderLoayoutWrapper>
          <CircularLoader />
        </MainLoaderLoayoutWrapper>
      ) : (
        <>
          {PaymentOfferRevamp.experimentEnabled && (
            <PaymentOffers
              isVisible={flowConfig?.offers && paymentScreen === PAYMENT_SCREENS.SAVED}
              offersData={offersData}
              platform={platform}
              visibleOfferBottomSheet={visibleOfferBottomSheet}
              setVisibleOfferBottomSheet={setVisibleOfferBottomSheet}
              savedPaymentPage={true}
              isAutoScroll={true}
              showCarouselDots={true}
              setLoading={setLoading}
              isApp={isApp}
            />
          )}
          {flowConfig?.wallet && isWalletDisplayed && !!walletBalance && (
            <SectionWrapper className="layout vertical prl20 payment-view">
              <h3 className="font-size-16 lh-24 font-semibold">{NykaaWalletTitle}</h3>
              <ErrorBoundary message="Failed to load wallet section" theme={theme}>
                <div
                  className={`${isFullPaymentByGiftCard &&
                    walletBalance >= grandTotal &&
                    "disabled-layer"}`}
                >
                  <WalletMultiModal
                    walletConfig={walletConfig}
                    giftCardConfig={giftCardConfig}
                    orderAmount={orderAmount}
                    setIsWalletChecked={setIsWalletChecked}
                  />
                </div>
              </ErrorBoundary>
            </SectionWrapper>
          )}
          {showRetryWalletTile && isRetryWalletExpEnabled && (
            <SectionWrapper>
              <RetryWalletTile
                nykaaWalletTitle={NykaaWalletTitle}
                handleRetryWalletClick={handleRetryWalletClick}
                unableToFetchWalletText={unableToFetchWalletText}
                retryButtonText={retryButtonText}
                theme={theme}
              />
            </SectionWrapper>
          )}
          {isSavedPaymentVisible && (
            <SavedPaymentView
              timerCallback={timerCallback}
              setUpiDetails={setUpiDetails}
              isGPayIntentAvailable={isGPayIntentAvailable}
              autoPayTmCreateOrder={autoPayTmCreateOrder}
            />
          )}
          {isNewPaymentMethodVisible && (
            <SavedPaymentWrapper
              className={`layout vertical payment-view visible-layer ${isFullPaymentByGiftCard &&
                "disabled-layer"}`}
              data-testid="lb_paymentMethods"
            >
              {!isSavedPaymentVisible && (
                <SectionTitleWrapper>
                  <Text
                    text={SavedPaymentOption}
                    font={theme.typography.sectionTitle}
                    color={theme.primaryText}
                    theme={theme}
                    data-testid="txt_saved_payment_option"
                  />
                </SectionTitleWrapper>
              )}
              <PaymentView
                orderAmount={orderAmount}
                giftCardConfig={giftCardConfig}
                walletConfig={walletConfig}
                timerCallback={timerCallback}
                setUpiDetails={setUpiDetails}
                isGPayIntentAvailable={isGPayIntentAvailable}
                paymentScreen={paymentScreen}
                showAllPaymentMethods={showAllPaymentMethods}
                newPaymentMethod={newPaymentMethod}
              />
            </SavedPaymentWrapper>
          )}

          {!PaymentOfferRevamp.experimentEnabled && (
            <PaymentOffers
              isVisible={flowConfig?.offers && paymentScreen === PAYMENT_SCREENS.SAVED}
              offersData={offersData}
              platform={platform}
              visibleOfferBottomSheet={visibleOfferBottomSheet}
              setVisibleOfferBottomSheet={setVisibleOfferBottomSheet}
              savedPaymentPage={true}
              isAutoScroll={true}
              showCarouselDots={true}
              setLoading={setLoading}
              isApp={isApp}
            />
          )}

          <MorePaymentMethod
            isVisible={
              areSavedPaymentMethodsDisplayed || isWalletDisplayed || isNewPaymentMethodVisible
            }
            setPaymentScreen={setPaymentScreen}
          />
          {flowConfig?.showPriceDetails && (
            <>
              {Boolean(Object.keys(cartInfo?.paymentDetails).length) && (
                <SectionTitleWrapper className="layout vertical mrl20 payment-view">
                  <Text
                    htmlText={OrderInformation}
                    font={theme.typography.sectionTitle}
                    color={theme.primaryText}
                    theme={theme}
                  />
                </SectionTitleWrapper>
              )}
              <NewPaymentDetails
                orderAmount={orderAmount}
                priceDetailConfig={priceDetailConfig}
                proceedToPayVisible={proceedToPayVisible}
                showBottomMargin={flowConfig?.edd && EddPosition2?.switchEnabled}
              />
            </>
          )}
          {flowConfig?.edd && (
            <DeliveryToast
              isToastVisible={isDeliveryEstimateToastVisible}
              toastDeliveryMessage={toastDeliveryMessage}
              setIsCheckButtonClickedOnToast={() => {}}
              setIsScrollToEddElement={setIsScrollToEddElement}
              setIsToastVisible={setIsDeliveryEstimateToastVisible}
            />
          )}
          <BuyerAssuranceWrapper>
            <BuyerAssurance
              text={getStringFromId(
                VERNACULAR_STRING_IDS.BUYER_ASSURANCE,
                VERNACULAR_DEFAULT_MESSAGES.BUYER_ASSURANCE
              )}
              icon={getIcons(platform, ICONS_NAMES.BUYERS_ASSURANCE_ICON)}
              theme={theme}
              className="buyer-assurance"
            />
          </BuyerAssuranceWrapper>
        </>
      )}
    </div>
  );
};
